var React = require('react');

function StageIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"fill":"#5649BE","cx":"16","cy":"16","r":"16","key":0}),React.createElement("path",{"d":"M9.922 10.667h10.396c.133 0 .254.073.315.19l2.614 4.978a.356.356 0 0 1 0 .33l-2.614 4.978a.356.356 0 0 1-.315.19H9.922a.356.356 0 0 1-.315-.52l2.44-4.648a.356.356 0 0 0 0-.33l-2.44-4.648a.356.356 0 0 1 .315-.52z","fill":"#FFF","key":1})]));
}

StageIcon.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = StageIcon;

StageIcon.default = StageIcon;
